module.exports = __webpack_public_path__ + "static/porqueimg4-2febe32b89c9b1494efec1ea4591b9f2.jpg";